import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100" id="faq">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2 font-label">常见问题</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            您关心的问题都在这里
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            快速了解开云平台的使用方式与服务保障，如有更多疑问欢迎联系客服
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800">{item.question}</span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
                  openId === item.id ? 'bg-primary-100 rotate-45' : 'bg-background-200'
                }`}>
                  <i className={`ri-add-line text-sm ${
                    openId === item.id ? 'text-primary-600' : 'text-foreground-400'
                  }`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? 'max-h-60 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-xs text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}